import { IQueryParamGlobalConfig } from '../classes/query-params-global-config.interface';

export const QueryParamGlobalConfig: IQueryParamGlobalConfig = {
  useBase64Encode: {
    queryParams: false,
    queryParamsUrlKey: 'query',
    backend: false,
  },
};
